export const CLIENT_GROUP_VALUES = [
  "quantilia",
  "demo",
  "preprod",
  "poc",
] as const;

export type ClientGroupValue = (typeof CLIENT_GROUP_VALUES)[number];

export const CLIENT_GROUP_OPTIONS: Array<{
  value: ClientGroupValue;
  label: string;
}> = [
  { value: "quantilia", label: "Quantilia" },
  { value: "demo", label: "Demo" },
  { value: "preprod", label: "Preprod" },
  { value: "poc", label: "Poc" },
];

export const DEFAULT_WORKSPACE_GROUP_KEY = "client";
export const DEFAULT_WORKSPACE_GROUP_LABEL = "Client";

const CLIENT_GROUP_SET = new Set<string>(CLIENT_GROUP_VALUES);

export function normalizeKnownClientGroup(
  rawGroup: string | null | undefined,
): ClientGroupValue | null {
  const normalized = (rawGroup ?? "").trim().toLowerCase();
  if (!normalized) return null;
  if (CLIENT_GROUP_SET.has(normalized)) return normalized as ClientGroupValue;
  return null;
}

export function normalizeWorkspaceGroupKey(
  rawGroup: string | null | undefined,
  options?: { fallbackToDefault?: boolean },
): string | null {
  const fallbackToDefault = options?.fallbackToDefault ?? true;
  const normalized = (rawGroup ?? "").trim().toLowerCase();
  const singular = normalized.endsWith("s")
    ? normalized.slice(0, -1)
    : normalized;

  if (!normalized) {
    return fallbackToDefault ? DEFAULT_WORKSPACE_GROUP_KEY : null;
  }

  if (singular === DEFAULT_WORKSPACE_GROUP_KEY) {
    return DEFAULT_WORKSPACE_GROUP_KEY;
  }

  const known =
    normalizeKnownClientGroup(normalized) ??
    normalizeKnownClientGroup(singular);
  if (known) return known;
  return fallbackToDefault ? DEFAULT_WORKSPACE_GROUP_KEY : null;
}

export function groupLabelFromValue(value: ClientGroupValue): string {
  return (
    CLIENT_GROUP_OPTIONS.find((opt) => opt.value === value)?.label ?? value
  );
}
